//
//
//
//
//
//
//
//
//
//
//

import AQLeftSideBar from "@/components/Generics/AQLeftSideBar/AQLeftSideBar.vue";

export default {
    name: "ViewAQLeftSideBar",
    components: {
        AQLeftSideBar
    }
};
